import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function MessagesView() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/admin/messages").then((r) => setItems(r.data || [])).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="admin-messages-view">
      <h2 className="font-display font-bold text-2xl mb-6">Messages</h2>
      {loading && <p className="text-fog-300">Loading…</p>}
      {!loading && items.length === 0 && <p className="text-fog-300">No messages yet.</p>}
      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.id} className="card-tech p-5" data-testid={`admin-message-${m.id}`}>
            <div className="flex flex-wrap items-center gap-3 justify-between">
              <p className="overline">{m.created_at}</p>
              <span className={`tag-chip ${m.sent ? "!border-neon-green !text-neon-green" : ""}`}>
                {m.sent ? "EMAIL SENT" : "STORED ONLY"}
              </span>
            </div>
            <p className="font-display font-semibold mt-2">{m.subject}</p>
            <p className="text-fog-300 text-sm mt-1">{m.name} &lt;{m.email}&gt;</p>
            <p className="text-fog-100 text-sm whitespace-pre-wrap mt-3">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
